import { render, staticRenderFns } from "./AuditLogGroupCard.vue?vue&type=template&id=c4787be6&scoped=true"
import script from "./AuditLogGroupCard.vue?vue&type=script&lang=js"
export * from "./AuditLogGroupCard.vue?vue&type=script&lang=js"
import style0 from "./AuditLogGroupCard.vue?vue&type=style&index=0&id=c4787be6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4787be6",
  null
  
)

export default component.exports